export const getProperty = <TObject extends { [key: string]: any }, TPropertyValue>(
  obj: TObject,
  path: string,
  defaultValue = undefined,
): TPropertyValue => {
  const travel = (regexp: any) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? (res[key] as any) : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj
    ? (defaultValue as TPropertyValue)
    : (result as unknown as TPropertyValue);
};

export const getKeyByValue = <T extends string | number>(object: { [key: string]: T }, value: T): string => {
  const index = Object.values(object).indexOf(value);

  const key = Object.keys(object)[index];

  return key;
};
